import React from "react";
import { RiDeleteBack2Fill } from "react-icons/ri";
// Il file definisce due componenti: List (principale, esportato) e Person (helper, usato internamente).

const List = (props) => { //Riceve props.data (un array di persone) e props.removeItem (una funzione per eliminare)
  return (
    <>
      <ul className="user-list">
         {props.data.map((person) => ( //Con .map() itera l'array e crea un <li> per ogni persona
          <li key={person.id}>  
          {/* key={person.id} — React richiede una chiave univoca per ogni elemento di una lista, per tracciare i cambiamenti in modo efficiente */}
                {" "}
                 <Person {...person} removeItem={props.removeItem}/> 
                 {/*
                Le persone erano nell'array, ma .map() le estrae una per una e le passa singolarmente a Person. */}
                {/* {...person} è lo spread operator: invece di scrivere nome={person.nome} img={person.img} ..., passa tutte le proprietà dell'oggetto in una volta sola */}
          </li>
         ))}
      </ul>
    </>  
  ) ;
};

const Person = ({id, nome, stato, img,data, ora, luogo, removeItem}) => { //Usa la destrutturazione direttamente nei parametri: estrae id, nome, stato, img, removeItem dalle props
  //Riceve tutto quello che List gli ha passato via spread + removeItem
  return (
    // <li>
      <article>
        <img src={img} className="person-img" alt="prs"/>
        <div className="person-info">
          <div className="person-action">
          <h4>{nome}</h4>
           <button className="btn" onClick={() => removeItem(id)}> 
            {/* () => removeItem(id) è una arrow function che "avvolge" la chiamata, altrimenti removeItem(id) verrebbe eseguito subito al render e non al click */}
               <RiDeleteBack2Fill className="icon" />{" "}
               {/* Il bottone chiama removeItem(id) al click — la funzione viene passata dall'alto (da App.js) e permette di eliminare la persona con quell'id */}
            </button>
           
        </div>
          <p>{stato}</p>
          <p>  {data}</p>
          <p>{ora}</p>
          <p>{luogo}</p>
          

        </div>
      </article>
    // </li>
  );
};

export default List;


// App.js
//   └── <List data={...} removeItem={...} />
//         └── List mappa l'array
//               └── <Person id nome stato img removeItem /> per ogni elemento

// I dati scendono dall'alto verso il basso (props), mentre l'azione di eliminazione risale verso App.js tramite la funzione removeItem.




// package.json vecchio: 
// "scripts": {
//     "start": "react-scripts start",
//     "build": "react-scripts build",
//     "test": "react-scripts test",
//     "eject": "react-scripts eject"
//   },